module.exports = __webpack_public_path__ + "img/SCC_Neutrophils.42e66074.png";